import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer style={{background: '#0f172a', color: 'white', padding: '4rem 0 2rem', borderTop: '1px solid rgba(6, 182, 212, 0.2)'}}>
      <div className="container">
        <div style={{display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: '3rem', marginBottom: '3rem'}}>
          <div>
            {/* Custom Logo Design: CARGO + Marketing Icon + ENGAGE */}
            <div style={{display: 'flex', alignItems: 'center', gap: '0.5rem', marginBottom: '1.5rem', fontFamily: 'Space Grotesk', fontSize: '1.5rem', fontWeight: '700'}}>
              <span style={{color: '#ffffff'}}>CARGO</span>
              
              {/* Marketing/Campaign Megaphone Icon */}
              <svg width="32" height="32" viewBox="0 0 24 24" fill="none" style={{flexShrink: 0}}>
                {/* Megaphone body */}
                <path d="M19 4L5 8V16L19 20V4Z" fill="#06b6d4"/>
                <path d="M5 8L3 9V15L5 16" fill="#0891b2"/>
                {/* Sound waves */}
                <path d="M20 8C21 9 21 11 21 12C21 13 21 15 20 16" stroke="#ffffff" strokeWidth="2" strokeLinecap="round"/>
                <path d="M22 6C23.5 7.5 23.5 10.5 23.5 12C23.5 13.5 23.5 16.5 22 18" stroke="#ffffff" strokeWidth="2" strokeLinecap="round" opacity="0.7"/>
                {/* Handle */}
                <circle cx="5" cy="12" r="2" fill="#0891b2"/>
              </svg>
              
              <span style={{color: '#06b6d4'}}>ENGAGE</span>
            </div>
            <p style={{color: 'rgba(255,255,255,0.6)', lineHeight: '1.8', marginBottom: '1rem'}}>
              Professional lead generation and marketing services for the financial services industry.
            </p>
            <p style={{fontSize: '0.875rem', color: 'rgba(255,255,255,0.5)', marginBottom: '0.5rem'}}>
              <strong>Legal Entity:</strong> CARGO AUTOMOTIVE SERVICES INC
            </p>
            <p style={{fontSize: '0.875rem', color: 'rgba(255,255,255,0.4)', fontStyle: 'italic'}}>
              We are a lead generation company. We are not a lender and do not make credit decisions.
            </p>
          </div>
          
          <div>
            <h3 style={{fontSize: '1.125rem', fontWeight: '600', marginBottom: '1.5rem', color: '#06b6d4'}}>Services</h3>
            <div style={{display: 'flex', flexDirection: 'column', gap: '0.75rem'}}>
              <Link to="/services" style={{color: 'rgba(255,255,255,0.6)', textDecoration: 'none', transition: 'color 0.3s'}}>Lead Generation</Link>
              <Link to="/services" style={{color: 'rgba(255,255,255,0.6)', textDecoration: 'none', transition: 'color 0.3s'}}>SMS Marketing</Link>
              <Link to="/services" style={{color: 'rgba(255,255,255,0.6)', textDecoration: 'none', transition: 'color 0.3s'}}>Email Campaigns</Link>
              <Link to="/services" style={{color: 'rgba(255,255,255,0.6)', textDecoration: 'none', transition: 'color 0.3s'}}>Campaign Management</Link>
            </div>
          </div>
          
          <div>
            <h3 style={{fontSize: '1.125rem', fontWeight: '600', marginBottom: '1.5rem', color: '#06b6d4'}}>Legal</h3>
            <div style={{display: 'flex', flexDirection: 'column', gap: '0.75rem'}}>
              <Link to="/privacy" style={{color: 'rgba(255,255,255,0.6)', textDecoration: 'none', transition: 'color 0.3s'}}>Privacy Policy</Link>
              <Link to="/terms" style={{color: 'rgba(255,255,255,0.6)', textDecoration: 'none', transition: 'color 0.3s'}}>Terms of Service</Link>
              <Link to="/sms-terms" style={{color: 'rgba(255,255,255,0.6)', textDecoration: 'none', transition: 'color 0.3s'}}>SMS Terms</Link>
              <Link to="/compliance" style={{color: 'rgba(255,255,255,0.6)', textDecoration: 'none', transition: 'color 0.3s'}}>Compliance</Link>
              <Link to="/verification" style={{color: 'rgba(255,255,255,0.6)', textDecoration: 'none', transition: 'color 0.3s'}}>Verification</Link>
              <Link to="/opt-out" style={{color: 'rgba(255,255,255,0.6)', textDecoration: 'none', transition: 'color 0.3s'}}>Opt-Out</Link>
            </div>
          </div>
          
          <div>
            <h3 style={{fontSize: '1.125rem', fontWeight: '600', marginBottom: '1.5rem', color: '#06b6d4'}}>Contact</h3>
            <div style={{display: 'flex', flexDirection: 'column', gap: '0.75rem', color: 'rgba(255,255,255,0.6)'}}>
              <p><strong style={{color: 'rgba(255,255,255,0.8)'}}>CARGO AUTOMOTIVE SERVICES INC</strong></p>
              <p>306 Schunnemunk Street</p>
              <p>Monroe, NY 10950</p>
              <p>United States</p>
              <p>EIN: 83-2229681</p>
              <p>Owner: Mendel Friedman</p>
              <p style={{marginTop: '0.5rem'}}>info@cargoengage.com</p>
              <p>support@cargoengage.com</p>
            </div>
          </div>
        </div>
        
        <div style={{paddingTop: '2rem', borderTop: '1px solid rgba(255,255,255,0.1)', textAlign: 'center'}}>
          <p style={{color: 'rgba(255,255,255,0.4)', fontSize: '0.875rem'}}>
            © {new Date().getFullYear()} CARGO AUTOMOTIVE SERVICES INC (DBA: Cargo Engage). All rights reserved. | Lead Generation & Marketing Services
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
